import { render, staticRenderFns } from "./customerOEM.vue?vue&type=template&id=5359b8a8&scoped=true&"
import script from "./customerOEM.vue?vue&type=script&lang=js&"
export * from "./customerOEM.vue?vue&type=script&lang=js&"
import style0 from "./customerOEM.vue?vue&type=style&index=0&id=5359b8a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5359b8a8",
  null
  
)

export default component.exports